"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BDocNegative", {
  enumerable: true,
  get: function get() {
    return _BDocNegative["default"];
  }
});
Object.defineProperty(exports, "BDocPositive", {
  enumerable: true,
  get: function get() {
    return _BDocPositive["default"];
  }
});
Object.defineProperty(exports, "BDocAnalysisNegative", {
  enumerable: true,
  get: function get() {
    return _BDocAnalysisNegative["default"];
  }
});
Object.defineProperty(exports, "BDocAnalysisPositive", {
  enumerable: true,
  get: function get() {
    return _BDocAnalysisPositive["default"];
  }
});
Object.defineProperty(exports, "BDocApprovedNegative", {
  enumerable: true,
  get: function get() {
    return _BDocApprovedNegative["default"];
  }
});
Object.defineProperty(exports, "BDocApprovedPositive", {
  enumerable: true,
  get: function get() {
    return _BDocApprovedPositive["default"];
  }
});
Object.defineProperty(exports, "BDocBackNegative", {
  enumerable: true,
  get: function get() {
    return _BDocBackNegative["default"];
  }
});
Object.defineProperty(exports, "BDocBackPositive", {
  enumerable: true,
  get: function get() {
    return _BDocBackPositive["default"];
  }
});
Object.defineProperty(exports, "BDocDeniedNegative", {
  enumerable: true,
  get: function get() {
    return _BDocDeniedNegative["default"];
  }
});
Object.defineProperty(exports, "BDocDeniedPositive", {
  enumerable: true,
  get: function get() {
    return _BDocDeniedPositive["default"];
  }
});
Object.defineProperty(exports, "BDocFrontNegative", {
  enumerable: true,
  get: function get() {
    return _BDocFrontNegative["default"];
  }
});
Object.defineProperty(exports, "BDocFrontPositive", {
  enumerable: true,
  get: function get() {
    return _BDocFrontPositive["default"];
  }
});
Object.defineProperty(exports, "BDocIncomeNegative", {
  enumerable: true,
  get: function get() {
    return _BDocIncomeNegative["default"];
  }
});
Object.defineProperty(exports, "BDocIncomePositive", {
  enumerable: true,
  get: function get() {
    return _BDocIncomePositive["default"];
  }
});
Object.defineProperty(exports, "BDocOffPlasticNegative", {
  enumerable: true,
  get: function get() {
    return _BDocOffPlasticNegative["default"];
  }
});
Object.defineProperty(exports, "BDocOffPlasticPositive", {
  enumerable: true,
  get: function get() {
    return _BDocOffPlasticPositive["default"];
  }
});
Object.defineProperty(exports, "BDocOpenedNegative", {
  enumerable: true,
  get: function get() {
    return _BDocOpenedNegative["default"];
  }
});
Object.defineProperty(exports, "BDocOpenedPositive", {
  enumerable: true,
  get: function get() {
    return _BDocOpenedPositive["default"];
  }
});
Object.defineProperty(exports, "BDocRgNegative", {
  enumerable: true,
  get: function get() {
    return _BDocRgNegative["default"];
  }
});
Object.defineProperty(exports, "BDocRgPositive", {
  enumerable: true,
  get: function get() {
    return _BDocRgPositive["default"];
  }
});
Object.defineProperty(exports, "BDocResidenceNegative", {
  enumerable: true,
  get: function get() {
    return _BDocResidenceNegative["default"];
  }
});
Object.defineProperty(exports, "BDocResidencePositive", {
  enumerable: true,
  get: function get() {
    return _BDocResidencePositive["default"];
  }
});
Object.defineProperty(exports, "BDocSendNegative", {
  enumerable: true,
  get: function get() {
    return _BDocSendNegative["default"];
  }
});
Object.defineProperty(exports, "BDocSendPositive", {
  enumerable: true,
  get: function get() {
    return _BDocSendPositive["default"];
  }
});
Object.defineProperty(exports, "BSignatureDigitalNegative", {
  enumerable: true,
  get: function get() {
    return _BSignatureDigitalNegative["default"];
  }
});
Object.defineProperty(exports, "BSignatureDigitalPositive", {
  enumerable: true,
  get: function get() {
    return _BSignatureDigitalPositive["default"];
  }
});
Object.defineProperty(exports, "BSignaturePaperNegative", {
  enumerable: true,
  get: function get() {
    return _BSignaturePaperNegative["default"];
  }
});
Object.defineProperty(exports, "BSignaturePaperPositive", {
  enumerable: true,
  get: function get() {
    return _BSignaturePaperPositive["default"];
  }
});

var _BDocNegative = _interopRequireDefault(require("./BDocNegative"));

var _BDocPositive = _interopRequireDefault(require("./BDocPositive"));

var _BDocAnalysisNegative = _interopRequireDefault(require("./BDocAnalysisNegative"));

var _BDocAnalysisPositive = _interopRequireDefault(require("./BDocAnalysisPositive"));

var _BDocApprovedNegative = _interopRequireDefault(require("./BDocApprovedNegative"));

var _BDocApprovedPositive = _interopRequireDefault(require("./BDocApprovedPositive"));

var _BDocBackNegative = _interopRequireDefault(require("./BDocBackNegative"));

var _BDocBackPositive = _interopRequireDefault(require("./BDocBackPositive"));

var _BDocDeniedNegative = _interopRequireDefault(require("./BDocDeniedNegative"));

var _BDocDeniedPositive = _interopRequireDefault(require("./BDocDeniedPositive"));

var _BDocFrontNegative = _interopRequireDefault(require("./BDocFrontNegative"));

var _BDocFrontPositive = _interopRequireDefault(require("./BDocFrontPositive"));

var _BDocIncomeNegative = _interopRequireDefault(require("./BDocIncomeNegative"));

var _BDocIncomePositive = _interopRequireDefault(require("./BDocIncomePositive"));

var _BDocOffPlasticNegative = _interopRequireDefault(require("./BDocOffPlasticNegative"));

var _BDocOffPlasticPositive = _interopRequireDefault(require("./BDocOffPlasticPositive"));

var _BDocOpenedNegative = _interopRequireDefault(require("./BDocOpenedNegative"));

var _BDocOpenedPositive = _interopRequireDefault(require("./BDocOpenedPositive"));

var _BDocRgNegative = _interopRequireDefault(require("./BDocRgNegative"));

var _BDocRgPositive = _interopRequireDefault(require("./BDocRgPositive"));

var _BDocResidenceNegative = _interopRequireDefault(require("./BDocResidenceNegative"));

var _BDocResidencePositive = _interopRequireDefault(require("./BDocResidencePositive"));

var _BDocSendNegative = _interopRequireDefault(require("./BDocSendNegative"));

var _BDocSendPositive = _interopRequireDefault(require("./BDocSendPositive"));

var _BSignatureDigitalNegative = _interopRequireDefault(require("./BSignatureDigitalNegative"));

var _BSignatureDigitalPositive = _interopRequireDefault(require("./BSignatureDigitalPositive"));

var _BSignaturePaperNegative = _interopRequireDefault(require("./BSignaturePaperNegative"));

var _BSignaturePaperPositive = _interopRequireDefault(require("./BSignaturePaperPositive"));